import { useState, useEffect, Fragment } from "react";
import Loader from "react-loader-spinner";
import GetSuperCounselorStudentService from "../../../services/SuperCounselor/GetStudentService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import CustomLoader from "../../customLoader/CustomLoader";
import "./DownloadStudentSummary.css";
const DownloadStudentSummary = () => {
  const [selectedGoal, setSelectedGoal] = useState("");
  const [publishData, setPublishData] = useState();
  const [user] = useState(localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const getPublishData = () => {
    let obj = {
      school_id: user?.school_id
    };
    setLoading(true);
    GetSuperCounselorStudentService.goalPublishManage(obj).then(data => {
      setPublishData(data.data.data);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  };
  const handleGoalChange = e => {
    setSelectedGoal(e.target.value);
  };
  const getGoalData = () => {
    if (!selectedGoal) return;
    let obj = {
      school_id: user?.school_id,
      goal_id: selectedGoal
    };
    const downloadFile = (downloadURL, fileName) => {
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      downloadLink.download = fileName;
      downloadLink.href = downloadURL;
      downloadLink.click();
    };
    setDownloading(true);
    GetSuperCounselorStudentService.studentStatistics(obj).then(data => {
      downloadFile(data.data.download, "My File");
    }).catch(() => {}).finally(() => setDownloading(false));
  };
  useEffect(() => {
    getPublishData();
  }, []);
  return <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          {loading ? <CustomLoader /> : <div className="download-status-page">
              <div className="download-status-header">
                <h1 className="download-status-title">
                  Download Progress Summary
                </h1>
                <p className="download-status-subtitle">
                  Select a goal and download the student status report
                </p>
              </div>

              <div className="download-status-card">
                <div className="download-status-field">
                  <label className="download-status-label">School</label>
                  <div className="download-status-school">
                    {user?.school_name}
                  </div>
                </div>

                <div className="download-status-field">
                  <label className="download-status-label" htmlFor="goal-select">
                    Goal
                  </label>
                  <select id="goal-select" className="download-status-select" onChange={handleGoalChange} value={selectedGoal}>
                  
                    <option value="" disabled>
                      Select Goal
                    </option>
                    {publishData?.map((item, index) => <option key={item?.id || index} value={item?.id}>
                        {item?.goal}
                      </option>)}
                  </select>
                  {(!publishData || publishData.length === 0) && <p className="download-status-empty">
                      No published goals available for download
                    </p>}
                
                </div>

                <div className="download-status-field">
                  <button type="button" className="download-status-btn" onClick={getGoalData} disabled={!selectedGoal || downloading}>
                  
                    {downloading ? "Downloading..." : "Download Report"}
                    {downloading && <Loader type="TailSpin" color="white" height={15} width={15} />}

                  
                  </button>
                  <p className="download-status-hint">
                    Downloads yellow and red student status progress summary for
                    the selected goal.
                  </p>
                </div>
              </div>
            </div>}
          
        </div>
      </div>
    </Fragment>;
};
export default DownloadStudentSummary;